import React from 'react'

import ChecklistFormHandler from './_form/ChecklistFormHandler'
import ChecklistLoader from './_load/ChecklistLoader'
import ConfigsLoader from '../../../containers/configs/_load/ConfigsLoader'
import EditChecklistForm from './EditChecklistForm'
import IntegrationsLoader from './_load/IntegrationsLoader'

const EditChecklistFormWrapper = ({ id }) => {
  return (
    <ConfigsLoader>
      <ChecklistLoader id={id}>
        <ChecklistFormHandler>
          <IntegrationsLoader>
            <EditChecklistForm />
          </IntegrationsLoader>
        </ChecklistFormHandler>
      </ChecklistLoader>
    </ConfigsLoader>
  )
}

export default EditChecklistFormWrapper
